import {
  DocumentType,
  DocumentTypeOption
} from '@thedealersconcierge/lib/codecs/document-type';
import { TFunction } from 'i18next';

/**
 * These options are merely Prefill for the Document Title
 *
 * We maintain a separate name between to be translated and original documenTitle
 * because we need a default document title to be stored in database
 *
 * TODO: Add documentType as an enum into Prisma
 */
export const documentTypeOptions = (
  t: TFunction,

  /**
   * This boolean added to make sure it is explicit that we want to include the Contract option
   * Contract Options should only be visible on the Dealership Scanner
   */
  includeContract: boolean
): DocumentTypeOption[] => {
  const options: DocumentTypeOption[] = [
    {
      value: 'INSURANCE_ID_CARD',
      label: t('Insurance ID Card'),
      documentTitle: 'Insurance ID Card'
    },

    {
      value: 'INSURANCE_BINDER',
      label: t('Insurance Binder'),
      documentTitle: 'Insurance Binder'
    },

    {
      value: 'TRADE_REGISTRATION',
      label: t('Trade Registration'),
      documentTitle: 'Trade Registration'
    },

    {
      value: 'BANK_STATEMENTS',
      label: t('Bank Statements'),
      documentTitle: 'Bank Statements'
    },
    {
      value: 'UTILITY_BILLS',
      label: t('Utility Bills'),
      documentTitle: 'Utility Bills'
    },
    {
      value: 'PROOF_OF_INCOME',
      label: t('Proof of Income'),
      documentTitle: 'Proof of Income'
    },

    {
      value: 'OTHER',
      label: t('Other'),
      documentTitle: 'Other'
    }
  ];

  if (includeContract) {
    options.push({
      value: 'CONTRACT',
      label: t('Contract'),
      documentTitle: 'Contract'
    });
  }

  return options;
};

// Used for document title that needs to be stored
export const getDocumentTitle = (value: DocumentType, t: TFunction) => {
  return (
    documentTypeOptions(t, true).find((option) => option.value === value)
      ?.documentTitle ?? value
  );
};
